import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Envío AP-7 · el catálogo se pide por estilo (3D, Plano, propios) y queda en
// memoria: con ~1.600 stickers por estilo no se vuelve a pedir en la sesión.
const cache = new Map();

/** Biblioteca de stickers PNG: propios + Microsoft Fluent Emoji (MIT). */
export const stickerService = {
  async listLibrary({ style } = {}) {
    const key = style || 'all';
    if (cache.has(key)) return cache.get(key);
    const res = await axios.get(`${API}/stickers/library`, { params: style ? { style } : {} });
    cache.set(key, res.data);
    return res.data;
  },
  _clearCache() { cache.clear(); },
};

export default stickerService;
